import React from 'react';

const UserTableFilters = ({ value, onChange, onClear }) => {
  const handleChange = (e) => {
    const { name, value: v } = e.target;
    onChange({ ...value, [name]: v });
  };

  return (
    <fieldset className='filters-bar'>
      <legend className='visually-hidden'>Filters</legend>
      <div className='row g-2'>
        <div className='col-6 col-md-2'>
          <input
            type='text'
            name='id'
            placeholder='ID'
            className='form-control form-control-sm'
            value={value.id}
            onChange={handleChange}
          />
        </div>
        <div className='col-6 col-md-2'>
          <input
            type='text'
            name='first'
            placeholder='First'
            className='form-control form-control-sm'
            value={value.first}
            onChange={handleChange}
          />
        </div>
        <div className='col-6 col-md-2'>
          <input
            type='text'
            name='last'
            placeholder='Last'
            className='form-control form-control-sm'
            value={value.last}
            onChange={handleChange}
          />
        </div>
        <div className='col-6 col-md-2'>
          <input
            type='text'
            name='username'
            placeholder='Username'
            className='form-control form-control-sm'
            value={value.username}
            onChange={handleChange}
          />
        </div>
        <div className='col-6 col-md-2'>
          <input
            type='text'
            name='email'
            placeholder='Email'
            className='form-control form-control-sm'
            value={value.email}
            onChange={handleChange}
          />
        </div>
        <div className='col-6 col-md-2'>
          <select
            name='admin'
            className='form-select form-select-sm'
            value={value.admin}
            onChange={handleChange}
          >
            <option value=''>Admin?</option>
            <option value='yes'>Yes</option>
            <option value='no'>No</option>
          </select>
        </div>
        <div className='col-12 col-md-2 mt-2 mt-md-0'>
          <button
            type='button'
            className='btn btn-outline-secondary btn-sm w-100'
            onClick={onClear}
          >
            Clear All
          </button>
        </div>
      </div>
    </fieldset>
  );
};

export default UserTableFilters;
